import { render, staticRenderFns } from "./SubMenuLayerRestrictions.vue?vue&type=template&id=186a873a&scoped=true"
import script from "./SubMenuLayerRestrictions.vue?vue&type=script&lang=js"
export * from "./SubMenuLayerRestrictions.vue?vue&type=script&lang=js"
import style0 from "./SubMenuLayerRestrictions.vue?vue&type=style&index=0&id=186a873a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a873a",
  null
  
)

export default component.exports